import { CodeBlockComponent } from './code-block';
import {
  HIVE_CODE_TOOLBAR_WIDGET,
  HiveCodeToolbarWidget,
} from './code-toolbar';
import { HiveCodeToolbar } from './code-toolbar/components/code-toolbar';
import { LanguageListButton } from './code-toolbar/components/lang-button';
import { HiveCodeUnit } from './highlight/hive-code-unit';

export function effects() {
  customElements.define('language-list-button', LanguageListButton);
  customElements.define('hive-code-toolbar', HiveCodeToolbar);
  customElements.define(HIVE_CODE_TOOLBAR_WIDGET, HiveCodeToolbarWidget);
  customElements.define('hive-code-unit', HiveCodeUnit);
  customElements.define('hive-code', CodeBlockComponent);
}

declare global {
  interface HTMLElementTagNameMap {
    'language-list-button': LanguageListButton;
    'hive-code-toolbar': HiveCodeToolbar;
    [HIVE_CODE_TOOLBAR_WIDGET]: HiveCodeToolbarWidget;
  }
}
